export const PASSWORD = "/password";
export const RESET_PASSWORD = `${PASSWORD}/reset`;
export const SETUP_PASSWORD = `${PASSWORD}/setup`;

export const linkTo = {
  resetPassword: token => `${RESET_PASSWORD}?token=${token}`,
  setupPassword: token => `${SETUP_PASSWORD}?token=${token}`,
};
